"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
require("./projects/app.projects.subModule");
require("./content/app.content.subModule");
angular.module('oneClickFactory.partner', [
    'ngSanitize',
    'ngStorage',
    'oneClickFactory.partner.projects',
    'oneClickFactory.partner.content',
]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwLnBhcnRuZXIubW9kdWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYXBwLnBhcnRuZXIubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaUNBQW1DO0FBRW5DLDZDQUEyQztBQUMzQywyQ0FBeUM7QUFFekMsT0FBTyxDQUFDLE1BQU0sQ0FBQyx5QkFBeUIsRUFBRTtJQUN0QyxZQUFZO0lBQ1osV0FBVztJQUNYLGtDQUFrQztJQUNsQyxpQ0FBaUM7Q0FDcEMsQ0FBQyxDQUFDIn0=